export const onOpenReportEmail = (subject: string) =>
  window.open(
    `mailto:support@monarchmoney.com?subject=${subject}`,
    '_blank',
    'noopener,noreferrer',
  );
